const baseUrl = "/v1/admin/customer/access-code";
export const apiUrls = {
  list: `${baseUrl}`,
  create: `${baseUrl}/create`,
  update: (id: number): string => `${baseUrl}/${id}/update`,
  // delete: (id: number): string => `${baseUrl}/${id}/delete`,
  details: (id: number): string => `${baseUrl}/${id}/details`,
  changeStatus: (id: number): string => `${baseUrl}/${id}/change-status`,
  export: (id: number): string => `${baseUrl}/${id}/export`,
  getIndustry: (customer_id: number): string => `${baseUrl}/${customer_id}/industry`,
  customerAccessList: `${baseUrl}/list`,
};
